import { Component, Input, OnInit } from '@angular/core';
import { MinimumStockService } from '@boma/supplier-portal/shared/services';

@Component({
  selector: 'boma-stock-low-stock',
  templateUrl: './stock-low-stock.component.html',
  styleUrls: ['./stock-low-stock.component.css'],
})
export class StockLowStockComponent implements OnInit {
  @Input() locationIds: string[] = null;
  @Input() organizationId: string;
  stockBelowMinimum: any;
  loaded = false;
  loading = true;

  paginationData: {
    totalItems: number;
    totalPages: number;
    previousPage: number;
    nextPage: number;
  };
  currentPage = 1;
  error = null;

  columns = [
    {
      field: 'product',
      header: 'Product Name',
      converter: (val) => {
        return val?.name;
      },
    },
    {
      field: 'location',
      header: 'Location',
      converter: (val) => {
        return val?.name;
      },
    },
    {
      field: 'minimumStockLevel',
      type: 'number',
      header: 'Minimum Stock Level',
    },
    { field: 'currentStock', type: 'number', header: 'Current Stock' },
    {
      field: 'stockDeficit',
      type: 'number',
      header: 'Stock Deficit',
      converter: (val) => {
        return val * -1;
      },
    },

    { field: 'cost', type: 'currency', header: 'Cost', converter: (val) => {
      return !val ? 0 : val;
    } },
    { field: 'price', type: 'currency', header: 'Price' },
  ];

  constructor(private minimumStockService: MinimumStockService) {}

  ngOnInit(): void {
    this.loadStockBelowMinimum();
  }

  handleChangePageClicked(ev = null) {
    if (ev === this.currentPage) return;
    this.currentPage = ev;

    this.loadStockBelowMinimum();
  }

  loadStockBelowMinimum(): void {
    this.loading = true;
    const entityId = this.organizationId;
    const page = this.currentPage;
    const pageSize = 15;
    const locationIds = this.locationIds;
    this.minimumStockService
      .getStockBelowMinimum(entityId, page, pageSize, locationIds)
      .subscribe({
        next: (x) => {
          this.error = null;
          this.stockBelowMinimum = x;
          this.loaded = true;
          this.loading = false;
          this.paginationData = {
            totalItems: x.totalItems,
            totalPages: x.totalPages,
            previousPage: x.previousPage,
            nextPage: x.nextPage,
          };
        },
        error: (error) => {
          this.error = error;
          this.loading = false;
        },
      });
  }
}
